import React from 'react';
import HeroBanner from '../../components/HeroBanner/HeroBanner';
import CategoryGrid from '../../components/CategoryGrid/CategoryGrid';
import ProductSection from '../../components/ProductSection/ProductSection';
import BrandSection from '../../components/BrandSection/BrandSection';
import { useMetaTags } from '../../utils/useMetaTags';
import { useCatalog } from '../../context/CatalogContext';
import './Home.css';

const Home = () => {
  // SEO meta tags
  useMetaTags({
    title: 'Haksaltech | IT Solutions & Networking Products',
    description: 'Shop the latest IT products, networking solutions, and tech equipment at competitive prices. Quality brands like Mikrotik, Ubiquiti, Cisco, and more.',
    url: 'https://haksaltech.com',
    type: 'website'
  });

  // Filter products for different sections
  const { products } = useCatalog();

  const networkingProducts = products.filter(p => p.category === 'networking' || p.categorySlug === 'networking').slice(0, 8);
  const securityProducts = products.filter(p => p.category === 'security & surveillance' || p.categorySlug === 'security-&-surveillance').slice(0, 8);
  const telephonyProducts = products.filter(p => p.category === 'telephony' || p.categorySlug === 'telephony').slice(0, 8);
  const recommendedProducts = products.slice(0, 12);

  return (
    <div className="home-page">
      <HeroBanner />
      
      <CategoryGrid />

      <ProductSection 
        title="Popular Categories this Week"
        products={recommendedProducts}
        viewAllLink="/shop"
        brands={['Ubiquiti', 'Mikrotik', 'Panasonic', 'Grandstream', 'Fanvil', 'Cisco']}
      />

      <div className="promo-banners">
        <div className="container">
          <div className="promo-grid">
            <a href="/category/mikrotik" className="promo-banner">
              <div className="promo-content" style={{background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)'}}>
                <span className="promo-label">Top Brand</span>
                <h3>Mikrotik Netmetal 5Ghz</h3>
                <p>Point-to-Point Solution<br/>Ultra fast speed for up to 50Km range</p>
                <span className="promo-price">from ₦385,352.00</span>
              </div>
            </a>
            <a href="/category/smart-home" className="promo-banner">
              <div className="promo-content" style={{background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)'}}>
                <span className="promo-label">New Arrival</span>
                <h3>Smart WiFi Video Door Bell</h3>
                <p>2-Way Audio Intercom<br/>HD Video & Night Vision</p>
                <span className="promo-cta">Shop Now →</span>
              </div>
            </a>
          </div>
        </div>
      </div>

      <ProductSection 
        title="Wireless Networking"
        products={networkingProducts}
        viewAllLink="/category/networking"
        brands={['Mikrotik', 'Cambium', 'Ubiquiti', 'Grandstream']}
      />

      <ProductSection 
        title="Telephony"
        products={telephonyProducts}
        viewAllLink="/category/telephony"
        brands={['Grandstream', 'Fanvil', 'Cisco IP Phone', 'Panasonic']}
      />

      <BrandSection />

      <ProductSection 
        title="Security & Surveillance"
        products={securityProducts}
        viewAllLink="/category/security-&-surveillance"
        brands={['Hikvision', 'Grandstream', 'Generic']}
      />

      <ProductSection 
        title="Recommendation For You"
        products={recommendedProducts}
        viewAllLink="/shop"
      />

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">🚚</div>
              <div className="feature-content">
                <h4>Fast Delivery</h4>
                <p>Nationwide delivery within 3-5 business days</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🔒</div>
              <div className="feature-content">
                <h4>Secure Payment</h4>
                <p>Multiple secure payment options available</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">💬</div>
              <div className="feature-content">
                <h4>24/7 Support</h4>
                <p>Get help anytime via WhatsApp or phone</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">↩️</div>
              <div className="feature-content">
                <h4>Easy Returns</h4>
                <p>Hassle-free returns within 7 days</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
